document.addEventListener('DOMContentLoaded', () => {
  // --- UI Helpers ---
  function openDrawer(id) {
    const el = document.getElementById(id);
    if (!el) return;
    el.classList.remove('invisible');

    // For cart drawer animation
    const container = el.querySelector('#cart-container');
    const overlay = el.querySelector('#cart-overlay');
    if (container) {
      setTimeout(() => {
        container.classList.remove('translate-x-full');
        if (overlay) overlay.classList.remove('opacity-0');
      }, 10);
    }

    // For search modal animation
    if (id === 'search-modal') {
      setTimeout(() => {
        el.classList.remove('opacity-0');
      }, 10);
    }
  }

  function closeDrawer(id) {
    const el = document.getElementById(id);
    if (!el) return;

    // For cart drawer animation
    const container = el.querySelector('#cart-container');
    const overlay = el.querySelector('#cart-overlay');

    if (container) {
      container.classList.add('translate-x-full');
      if (overlay) overlay.classList.add('opacity-0');
      setTimeout(() => el.classList.add('invisible'), 300);
    } else if (id === 'search-modal') {
      el.classList.add('opacity-0');
      setTimeout(() => el.classList.add('invisible'), 300);
    } else {
      el.classList.add('invisible');
    }
  }

  // --- Cart Drawer ---
  // Hijack all cart links
  const cartTriggers = document.querySelectorAll('a[href="/cart"]');
  cartTriggers.forEach(trigger => {
    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      openDrawer('cart-drawer');
    });
  });

  const cartClose = document.getElementById('cart-close');
  const cartOverlay = document.getElementById('cart-overlay');

  if (cartClose) cartClose.addEventListener('click', () => closeDrawer('cart-drawer'));
  if (cartOverlay) cartOverlay.addEventListener('click', () => closeDrawer('cart-drawer'));

  // --- Search Modal ---
  // Simple check for search buttons if we add a specific class later, 
  // but for now relying on manual triggers or specific IDs if we added them.
  const searchClose = document.getElementById('search-close');
  if (searchClose) searchClose.addEventListener('click', () => closeDrawer('search-modal'));

  // --- Header Scroll Effect ---
  const header = document.getElementById('site-header');
  if (header) {
    window.addEventListener('scroll', () => {
      if (window.scrollY > 50) {
        header.classList.add('scrolled');
      } else {
        header.classList.remove('scrolled');
      }
    });
  }

  // --- Global Access ---
  window.pfTheme = {
    openCart: () => openDrawer('cart-drawer'),
    openSearch: () => openDrawer('search-modal'),
    closeCart: () => closeDrawer('cart-drawer'),
    closeSearch: () => closeDrawer('search-modal')
  };
});

  // --- Variant Price Updater ---
  document.querySelectorAll('select[id^="pdp-variant-"]').forEach(function(select) {
    var pdpSection = select.closest('section[id^="pdp-"]');
    if (!pdpSection) return;

    // Build a map of variantId -> price from the product JSON
    var variantData = {};
    try {
      var scriptEl = pdpSection.querySelector('script[type="application/json"]');
      if (scriptEl) {
        var json = JSON.parse(scriptEl.textContent);
        if (json.variants) {
          json.variants.forEach(function(v) {
            variantData[String(v.id)] = v.price;
          });
        }
      }
    } catch(e) {}

    select.addEventListener('change', function() {
      var selectedVariantId = this.value;
      var priceEl = pdpSection.querySelector('[data-pdp-price]');
      if (!priceEl) return;

      // Use Shopify AJAX API to get accurate price
      fetch('/variants/' + selectedVariantId + '.js')
        .then(function(r) { return r.json(); })
        .then(function(variant) {
          var price = (variant.price / 100).toLocaleString('en-CA', {
            style: 'currency',
            currency: 'CAD'
          });
          priceEl.textContent = price;


                    // *** CRITICAL FIX: Update hidden variant ID so Add to Cart submits the right variant ***
          var hiddenInput = pdpSection.querySelector('input[name="id"]');
          if (hiddenInput) hiddenInput.value = selectedVariantId;

          // Also update Buy Now / dynamic checkout button if present
          var dynButtons = pdpSection.querySelectorAll('[data-shopify="payment-button"] button, .shopify-payment-button__button');
          dynButtons.forEach(function(btn) {
            // Shopify dynamic checkout reads the form's hidden id input automatically
            // Re-triggering a small DOM event refreshes it
            if (hiddenInput) {
              hiddenInput.dispatchEvent(new Event('change', { bubbles: true }));
            }
          });
          // Update compare-at price if present
          var compareEl = pdpSection.querySelector('[data-pdp-compare]');
          if (compareEl) {
            if (variant.compare_at_price && variant.compare_at_price > variant.price) {
              compareEl.textContent = (variant.compare_at_price / 100).toLocaleString('en-CA', {
                style: 'currency',
                currency: 'CAD'
              });
              compareEl.closest('.pdp__price-row') && compareEl.closest('.pdp__price-row').classList.remove('hidden');
            } else {
              compareEl.textContent = '';
            }
          }

          // Update add-to-cart button availability
          var addBtn = pdpSection.querySelector('[data-add-to-cart]');
          if (addBtn) {
            if (variant.available) {
              addBtn.disabled = false;
              addBtn.textContent = 'Add to cart';
            } else {
              addBtn.disabled = true;
              addBtn.textContent = 'Sold out';
            }
          }
        })
        .catch(function() {});
    });
  });
